
// src\themes\default\elements\Header\Header.tsx
import Image from 'next/image';
import Link from 'next/link';

import {
  getMainMenu,
  getSidebarMainMenu,
  getSidebarSecondaryMenu,
} from '@/core/lib/api/main/menu-api';
import { getSettings } from '@/core/lib/api/main/setting';
import { MenuItem, MenuResponseData } from '@/core/types/menuApi';

import HeaderContainer from './HeaderContainer';
import HeaderNavAction from './HeaderNavAction';
import HeaderNavMenu from './HeaderNavMenu';
import HeaderNavToggle from './HeaderNavToggle';
import Sidebar from './Sidebar';

export default async function Header() {
  try {
    const setting = await getSettings();
    const menuItemsData: MenuResponseData = await getSidebarMainMenu();
    const introductionSidebarData: MenuResponseData =
      await getSidebarSecondaryMenu();
    // منوی اصلی هدر دسکتاپ (HeaderNavMenu) فقط lg:flex هست و تو موبایل دیده
    // نمی‌شه؛ همین آیتم‌ها رو تو سایدبار موبایل هم نشون می‌دیم که از همون‌جا
    // در دسترس باشن
    const mainNavItems: MenuItem[] = await getMainMenu();

    if (!setting) {
      return (
        <header className="fixed top-0 inset-x-0 z-50 h-18 bg-primary-0 text-primary-900 flex items-center justify-between px-4 py-4 sm:px-6 lg:px-12">
          <div className="flex items-center gap-5 w-5/12">
            <div className="w-8 h-8 bg-gray-200 rounded"></div>
            <div className="w-8 h-8 bg-gray-200 rounded"></div>
          </div>
          <div className="flex items-center justify-center h-full w-2/12">
            <div className="w-10 h-10 bg-gray-200 rounded"></div>
          </div>
          <div className="w-5/12"></div>
        </header>
      );
    }

    return (
      <>
        <HeaderContainer>
          <div className="flex items-center gap-5 w-5/12">
            <HeaderNavToggle />
            <HeaderNavMenu />
          </div>
          <Link
            href="/"
            className="flex items-center justify-center h-full w-2/12"
          >

            {setting.logo_mobile && (
              <Image
                src={setting.logo_mobile}
                alt={setting.site_title || "Logo"}
                width={40}
                height={40}
                className="object-contain lg:hidden"
              />
            )}


            {setting.logo_desktop && (
              <Image
                src={setting.logo_desktop}
                alt={setting.site_title || "Logo"}
                width={140}
                height={70}
                className="object-contain hidden lg:group-data-[scrolled=false]/header:flex"
              />
            )}


            {setting.logo_footer && (
              <Image
                src={setting.logo_footer}
                alt={setting.site_title || "Logo"}
                width={140}
                height={70}
                className="object-contain hidden lg:group-data-[scrolled=true]/header:flex"
              />
            )}
          </Link>
          <HeaderNavAction />
        </HeaderContainer>
        <Sidebar
          mainItems={menuItemsData?.items || []}
          mainDescription={menuItemsData?.description || ""}
          introItems={introductionSidebarData?.items || []}
          introDescription={introductionSidebarData?.description || ""}
          navItems={mainNavItems || []}
        />
      </>
    );
  } catch {
    return (
      <header className="fixed top-0 inset-x-0 z-50 h-18 bg-primary-0 text-primary-900 flex items-center justify-between px-4 py-4 sm:px-6 lg:px-12">
        <div className="flex items-center gap-5 w-5/12">
          <div className="w-8 h-8 bg-gray-200 rounded"></div>
          <div className="w-8 h-8 bg-gray-200 rounded"></div>
        </div>
        <div className="flex items-center justify-center h-full w-2/12">
          <div className="w-10 h-10 bg-gray-200 rounded"></div>
        </div>
        <div className="w-5/12"></div>
      </header>
    );
  }
}